<template>
  <div>
    <b-breadcrumb class="breadcrumb">
      <b-breadcrumb-item href="/">
        <b-icon icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
        首页
      </b-breadcrumb-item>
      <b-breadcrumb-item href="/search-comp"> 企业列表 </b-breadcrumb-item>
      <b-breadcrumb-item active>企业详情</b-breadcrumb-item>
    </b-breadcrumb>

    <b-card no-body>
      <b-row align-v="center">
        <b-col cols="2">
          <b-img :src="compObj.compLogo" alt="Image 1" width="180" height="180"></b-img>
        </b-col>
        <b-col>
          <h4 class="mt-2 mb-1 text-left">{{ compObj.compName }}</h4>
          <div class="content-font job-prop">
            <b-icon icon="star-fill" variant="danger" scale="4" class="font-weight-bold pr-2 tag-height"></b-icon><label class="font-weight-bold">统一社会信用代码：</label>{{ compObj.orgCode }}
          </div>
          <div class="content-font job-prop">
            <b-icon icon="triangle-fill" variant="danger" scale="4" class="font-weight-bold pr-2 tag-height"></b-icon><label class="font-weight-bold">所属行业：</label>{{ compObj.bizIndustry }}
            <label class="font-weight-bold mr-2">|</label> <b-icon icon="shield-lock-fill" variant="danger" scale="4" class="font-weight-bold pr-2 tag-height"></b-icon
            ><label class="font-weight-bold">企业规模：</label>{{ compObj.bizSize }} <label class="font-weight-bold mr-2">|</label>
            <b-icon icon="question-square-fill" variant="danger" scale="4" class="font-weight-bold pr-2 tag-height"></b-icon><label class="font-weight-bold">企业性质：</label>{{ compObj.bizType }}
            <label class="font-weight-bold mr-2">| </label> <b-icon icon="grid-fill" variant="danger" scale="4" class="font-weight-bold pr-2 tag-height"></b-icon
            ><label class="font-weight-bold">注册资金：</label>{{ compObj.regCapital }}万元
          </div>
          <div class="content-font job-prop">
            <b-icon icon="flag-fill" variant="danger" scale="4" class="font-weight-bold pr-2 tag-height"></b-icon><label class="font-weight-bold">企业注册地址：</label>{{ compObj.compAddr }}
          </div>
          <div class="content-font job-prop">
            <b-icon icon="tag-fill" variant="danger" scale="4" class="font-weight-bold pr-2 tag-height"></b-icon><label class="font-weight-bold">入驻园区：</label>{{ compObj.compPark }}
          </div>
        </b-col>
      </b-row>
    </b-card>

    <b-card no-body class="border-0 mt-3">
      <b-row>
        <b-col>
          <div class="align-middle tag-height ml-4">
            <b-icon icon="people-fill" variant="danger" scale="2.5" class="font-weight-bold pr-2 tag-height tag-font-size"></b-icon><span class="ml-2 tag-height tag-font-size">招聘岗位</span>
            <span class="tag-font-size-small ml-2">温馨提示：投递简历前请点击页面右上角“登录”，登录成功后先去完善个人简历。需要获取更多系统功能，也请先登录然后进行操作。</span>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="2">
          <b-card header="企业招聘">
            <b-img :src="jyhQrcode" alt="Image 1" width="170" height="170"></b-img>
            <div class="job-prop">扫一扫上面的二维码，关注就业汇公众号，访问更加方便。</div>
          </b-card>
        </b-col>
        <b-col>
          <b-card body-bg-variant="light" body-class="card-body-outer">
            <template v-slot:header>
              <div class="d-flex flex-row align-items-center font-14">
                <b-form-select v-model="selectedWorkEnvi" :options="optionsWorkEnvi" size="sm"></b-form-select>
                <b-form-select v-model="selectedWorkMode" :options="optionsWorkMode" size="sm" class="ml-1"></b-form-select>
                <b-form-select v-model="selectedEducation" :options="optionsEducation" size="sm" class="ml-1"></b-form-select>
              </div>
              <div class="d-flex flex-row align-items-center mt-2 font-16">
                <b-form-input v-model="selectedJobName" type="search" size="sm" placeholder="请输入岗位名称"></b-form-input>
                <b-button variant="success" size="sm" block class="button-size ml-1" @click="dataSearch">检索</b-button>
                <b-button variant="success" size="sm" block class="mt-0 ml-1 button-size" @click="clearSearch">清空</b-button>
              </div>
            </template>

            <b-card-body class="card-body-outer">
              <b-card no-body class="border-0" v-for="(item, index) in jobList" :key="index">
                <div class="ml-3 mt-2 mr-3 mb-2">
                  <b-row class="mb-1" align-h="start">
                    <b-col cols="7" class="job-name text-truncate text-left">
                      <b-link :to="'/show-job/' + item.jobRecruitmentId" target="_self" class="news-list">{{ item.jobName }}</b-link>
                    </b-col>
                    <b-col class="job_salary text-danger text-truncate font-weight-bold text-right">{{ item.salaryRangeName }}</b-col>
                  </b-row>
                  <b-row class="mt-2 mb-1" align-h="start">
                    <b-col cols="12" class="job-prop text-muted text-truncate text-left align-middle tag-height">
                      <b-icon icon="trophy" variant="danger" scale="4" class="font-weight-bold pr-2 tag-height"></b-icon
                      ><span class="tag-height"
                        ><label class="font-weight-bold">工作模式：</label>{{ item.workingModeName }} <label class="font-weight-bold mr-2">| </label>
                        <b-icon icon="award" variant="danger" scale="5" class="font-weight-bold pr-2 tag-height"></b-icon><label class="font-weight-bold">学历要求：</label>{{ item.educationName }}
                        <label class="font-weight-bold mr-2">| </label> <b-icon icon="bucket-fill" variant="danger" scale="4" class="font-weight-bold pr-2 tag-height"></b-icon
                        ><label class="font-weight-bold">工作环境：</label>{{ item.workEnvirName }} <label class="font-weight-bold mr-2"> | </label>
                        <b-icon icon="info-square-fill" variant="danger" scale="4" class="font-weight-bold pr-2 tag-height"></b-icon><label class="font-weight-bold">伙食：</label
                        >{{ item.cateredName }}
                        <label class="font-weight-bold mr-2"> | </label>
                        <b-icon icon="info-square-fill" variant="danger" scale="4" class="font-weight-bold pr-2 tag-height"></b-icon><label class="font-weight-bold">工作经验：</label
                        >{{ item.workExperienceName }}</span
                      ></b-col
                    >
                  </b-row>
                  <b-row class="mt-2" align-h="start">
                    <b-col cols="10" class="job-prop text-body text-truncate text-left align-middle tag-height">
                      <span class="tag-height">
                        <b-icon icon="people-fill" variant="danger" scale="5" class="font-weight-bold pr-2 tag-height"></b-icon><label class="font-weight-bold">拟招：</label>{{ item.headcount }}人
                        <label class="font-weight-bold mr-2">| </label>
                        <b-icon icon="geo" variant="danger" scale="4" class="font-weight-bold pr-2 tag-height"></b-icon><label class="font-weight-bold">工作地点：</label>{{ item.workingPlace }}</span
                      ></b-col
                    >
                    <b-col class="text-right">
                      <b-button :href="$ADMIN_URL" target="admin_window" variant="success" size="sm" block class="mt-0 ml-1 button-size">投递简历</b-button>
                    </b-col>
                  </b-row>
                </div>
              </b-card>

              <div class="d-flex flex-row justify-content-center font-14">
                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" class="mt-4">
                  <template v-slot:first-text><span class="text-success">首页</span></template>
                  <template v-slot:prev-text><span class="text-danger">前页</span></template>
                  <template v-slot:next-text><span class="text-warning">后页</span></template>
                  <template v-slot:last-text><span class="text-info">尾页</span></template>
                  <template v-slot:ellipsis-text>
                    <b-spinner small type="grow"></b-spinner>
                    <b-spinner small type="grow"></b-spinner>
                    <b-spinner small type="grow"></b-spinner>
                  </template>
                  <template v-slot:page="{page, active}">
                    <b v-if="active">{{ page }}</b>
                    <i v-else>{{ page }}</i>
                  </template>
                </b-pagination>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import JyhQrcode from '@/assets/jyh-qrcode.jpg'

export default {
  name: 'ShowComp',
  data() {
    return {
      selectedWorkMode: null,
      optionsWorkMode: [{value: null, text: '请选择工作模式'}],
      selectedEducation: null,
      optionsEducation: [{value: null, text: '请选择学历要求'}],
      selectedWorkEnvi: null,
      optionsWorkEnvi: [{value: null, text: '请选择工作环境要求'}],
      selectedJobName: null,
      // 企业id
      compId: undefined,
      // 企业详情
      compObj: {
        compLogo: '',
        compName: '',
        orgCode: '',
        bizIndustry: '',
        bizSize: '',
        bizType: '',
        regCapital: ''
      },
      // 当前企业下有效招聘岗位列表
      jobList: [],
      // 就业汇公众号二维码
      jyhQrcode: JyhQrcode,
      rows: 100,
      perPage: 62,
      currentPage: 1
    }
  },
  created() {
    this.compId = this.$route.params.id
  },
  mounted() {
    this.fetchWorkModeList()
    this.fetchEducationList()
    this.fetchWorkEnvirList()
    this.fetchInfo()
    this.fetchJobList()
  },
  methods: {
    /**
     * 获取有效的工作模式字典列表
     */
    fetchWorkModeList() {
      const that = this
      const postData = {}
      that
        .$http({
          method: 'post',
          url: '/portal/work-mode-list',
          data: postData
        })
        .then((d) => {
          const dSize = d.length
          that.optionsWorkMode = [{value: null, text: '请选择工作模式'}]
          for (let i = 0; i < dSize; i++) {
            const id = d[i].workModeId
            const name = d[i].workModeName
            const mp = {
              value: id,
              text: name
            }
            that.optionsWorkMode.push(mp)
          }
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取有效的工作模式字典列表失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    },
    /**
     * 获取有效的学历字典列表
     */
    fetchEducationList() {
      const that = this
      const postData = {}
      that
        .$http({
          method: 'post',
          url: '/portal/education-list',
          data: postData
        })
        .then((d) => {
          const dSize = d.length
          that.optionsEducation = [{value: null, text: '请选择学历要求'}]
          for (let i = 0; i < dSize; i++) {
            const id = d[i].educationId
            const name = d[i].educationName
            const mp = {
              value: id,
              text: name
            }
            that.optionsEducation.push(mp)
          }
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取有效的学历字典列表失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    },
    /**
     * 获取有效的工作环境字典列表
     */
    fetchWorkEnvirList() {
      const that = this
      const postData = {}
      that
        .$http({
          method: 'post',
          url: '/portal/work-envir-list',
          data: postData
        })
        .then((d) => {
          const dSize = d.length
          that.optionsWorkEnvi = [{value: null, text: '请选择工作环境要求'}]
          for (let i = 0; i < dSize; i++) {
            const id = d[i].workEnvirId
            const name = d[i].workEnvirName
            const mp = {
              value: id,
              text: name
            }
            that.optionsWorkEnvi.push(mp)
          }
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取有效的工作环境字典列表失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    },
    /**
     * 获取企业详情
     */
    fetchInfo() {
      const that = this
      const postData = {
        id: that.compId
      }
      that
        .$http({
          method: 'post',
          url: '/portal/comp-info',
          data: postData
        })
        .then((d) => {
          this.compObj = d
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取企业详情失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    },
    /**
     * 获取当前企业下的有效招聘岗位列表
     */
    fetchJobList() {
      const that = this
      const postData = {
        pageNo: that.currentPage,
        pageSize: that.perPage,
        compId: that.compId
      }
      that
        .$http({
          method: 'post',
          url: '/portal/job-page-by-comp-id',
          data: postData
        })
        .then((d) => {
          that.rows = d.total
          that.perPage = d.size
          that.currentPage = d.pages === 0 ? 1 : d.pages
          const records = d.records
          this.jobList = records
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取当前企业下的有效招聘岗位列表失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    },
    // 清空筛选条件
    clearSearch() {
      this.selectedWorkMode = null
      this.selectedEducation = null
      this.selectedWorkEnvi = null
      this.selectedJobName = null
    },
    // 筛选数据
    dataSearch() {
      const that = this
      const postData = {
        pageNo: that.currentPage,
        pageSize: that.perPage,
        compId: that.compId,
        workModeId: that.selectedWorkMode,
        educationId: that.selectedEducation,
        workEnviId: that.selectedWorkEnvi,
        jobName: that.selectedJobName
      }
      that
        .$http({
          method: 'post',
          url: '/portal/job-page-by-comp-id',
          data: postData
        })
        .then((d) => {
          that.rows = d.total
          that.perPage = d.size
          that.currentPage = d.pages === 0 ? 1 : d.pages
          const records = d.records
          this.jobList = records
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取当前企业下的有效招聘岗位列表失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.font-16 {
  font-size: 16px;
}
.font-14 {
  font-size: 14px;
}
.tag-height {
  line-height: 30px;
}
.tag-font-size {
  font-size: 22px;
}
.tag-font-size-small {
  font-size: 14px;
}
.button-size {
  width: 120px;
}
.job-name {
  font-size: 20px;
  font-weight: bolder;
}
.job-prop {
  font-size: 14px;
}
.job_salary {
  font-size: 18px;
}
.card-body-outer {
  padding-top: 5px;
  padding-bottom: 5px;
}
.card-body {
  padding-left: 0px;
  padding-right: 0px;
}
// 设置输入框、下拉选择框、按钮的字体大小
.form-control-sm {
  font-size: 14px;
}
.custom-select-sm {
  font-size: 14px;
}
.btn-sm,
.btn-group-sm > .btn {
  font-size: 14px;
}
</style>
